import styled from 'styled-components'
import { grayText, white, black, purple, purpleSec } from 'theme/colors'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 24px;
  width: 450px;
  min-height: 214px;
  background: ${white};
  box-shadow: 0px 4px 74px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  margin-bottom: 24px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
  gap: 16px;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
`

export const Title = styled.h3`
  width: 100%;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  text-align: center;
  color: ${black};
  margin: 0;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
`

export const InfoText = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  color: ${grayText};
  margin: 0;
`

export const ActionButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 300px;
  height: 40px;
  background: ${purpleSec};
  border-radius: 4px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 154.7%;
  text-align: center;
  color: ${purple};
`
